export const NONCE_COOKIE = 'drop-nonce';

export const DAILY_DROP_LIMIT_COOKIE = 'daily-drop-limit';

export const CHECKOUT_SECRET_KEY = 'deadrop_checkout_secret';
